<template>
  <v-container>
    <v-form ref="form2" v-on:submit.prevent v-model="isValid" lazy-validation>
      <v-container>
        <v-row>
          <v-col>
            <v-textarea
              v-for="(etape, index) in etapes"
              :key="index"
              prepend-icon="mdi-order-bool-ascending-variant"
              :label="'Étape(s) ' + (index + 1)"
              required
              v-model="etapes[index]"
              :append-outer-icon="
                index === 0 && etapes.length < 10
                  ? 'mdi-plus'
                  : index != 0
                  ? 'mdi-delete'
                  : ''
              "
              @click:append-outer="
                index === 0 && etapes.length < 10
                  ? addUser(etapes.length)
                  : index != 0
                  ? deleteUser(index)
                  : ''
              "
              maxlength="2000"
              counter
              :rules="basicRules"
            >
              <template v-if="index === 0" v-slot:prepend-inner>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  Vous devez ici renseigner la procédure pas à pas de votre
                  activité dans le but de fournir un protocole clair et
                  accessible. Veuillez essayer de faire apparaitre une démarche
                  de progressivité en termes de difficulté.
                </v-tooltip>
              </template>
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              prepend-icon="mdi-poll-box-outline"
              label="Ligne de base"
              v-model="moyensMesure"
              :rules="basicRules"
            >
              <template v-slot:append-outer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  Fournir un moyen de mesurer les progressions de votre patient
                  est toujours plus appréciable en termes d’objectivation (ex.
                  grille de progression, pourcentage de réussite etc.).
                </v-tooltip>
              </template>
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              prepend-icon="mdi-alert-outline"
              label="Précautions/Contres-indications/Informations complémentaires"
              required
              v-model="precautions"
              :rules="basicRules"
            >
              <template v-slot:append-outer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  Veuillez renseigner ici les éventuelles contre-indications ou
                  précautions à prendre avec votre activité.
                </v-tooltip>
              </template>
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              prepend-icon="mdi-swap-horizontal"
              label="Gestion des capacités de transfert"
              v-model="gestionCapicitesTransfert"
              :rules="basicRules"
            >
              <template v-slot:append-outer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  Il s’agit ici de renseigner ou de porter une réflexion sur les
                  moyens de transferts horizontaux et verticaux possibles d’une
                  activité. Le but étant la généralisation des acquis dans la
                  vie quotidienne.
                </v-tooltip>
              </template>
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              prepend-icon="mdi-pencil-outline"
              label="Cadre théorique"
              v-model="cadreTheorique"
              :rules="basicRules"
            >
              <template v-slot:append-outer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  Il est préférable de renseigner les fondements théoriques de
                  l’activité s’ils sont existants.
                </v-tooltip>
              </template>
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div style="text-align:right">
              <v-btn class="mr-2" @click="addAndSaveDraft()">{{
                $t("saveDraft")
              }}</v-btn>
              <v-btn @click="previousStep()">{{ $t("previousStep") }}</v-btn>
              <v-btn @click="add()" :disabled="!isFormValid">{{
                $t("nextStep")
              }}</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Step2",
  created() {
    if (this.isDraft) {
      this.loadDataDraft();
    }
  },
  computed: {
    ...mapGetters({
      activity: "activities/getActivity"
    }),
    isFormValid() {
      return (
        this.precautions && this.etapes && this.etapes[0] !== "" && this.isValid
      );
    }
  },
  props: {
    previousStep: { type: Function },
    nextStep: { type: Function },
    saveDraft: { type: Function },
    isDraft: { type: Boolean }
  },
  methods: {
    ...mapActions({ validateStep2: "activities/validateStep2" }),
    add() {
      if (this.validate()) {
        this.validateStep2(this.constructActivityStep2());
        this.nextStep();
      }
    },
    loadDataDraft() {
      this.etapes = this.activity.etapes.length > 0 ? this.activity.etapes : [""];
      this.moyensMesure = this.activity.moyensMesure;
      this.precautions = this.activity.precautions;
      this.gestionCapicitesTransfert = this.activity.gestionCapicitesTransfert;
      this.cadreTheorique = this.activity.cadreTheorique;
    },
    addAndSaveDraft() {
      this.validateStep2(this.constructActivityStep2());
      this.saveDraft();
    },
    constructActivityStep2() {
      return {
        etapes: this.etapes,
        moyensMesure: this.moyensMesure,
        precautions: this.precautions,
        gestionCapicitesTransfert: this.gestionCapicitesTransfert,
        cadreTheorique: this.cadreTheorique
      };
    },
    deleteUser: function(index) {
      this.etapes.splice(index, 1);
      if (index === 0) this.addUser();
    },
    addUser: function(index) {
      if (index < 10) {
        this.etapes.push("");
      }
    },
    validate() {
      return this.$refs.form2.validate();
    }
  },
  data() {
    return {
      isValid: false,
      etapes: [""],
      moyensMesure: "",
      precautions: "",
      gestionCapicitesTransfert: "",
      cadreTheorique: "",
      basicRules: [v => !!v || "Ce champ est requis"]
    };
  }
};
</script>

<style scoped>
.font-size-stars {
  font-size: 26px;
}
</style>
